import * as types from 'store/mutation-types'
import api from 'store/api'
import Vue from 'vue'

const _isFalsy = val =>
  _.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = val => !_isFalsy(val)

const requestCancel = {
  token: Vue.axios.CancelToken,
  source: null
}

const state = {
  agencies: [],
  organizations: [],
  filters: null,
  customers: [],
  payments_methods: [],
  validation_requests: [],
  customers_for_add_cash: [],
  customer_cashings_payment_methods: null,
  cashing_created_and_waiting_for_payment: null,
  cashings: [],
  invoices: [],
  organizations: [],
  balance: {},
  errors:[],
}

const mutations = {
  [types.CASH_AGENCIES_WITH_ORGANIZATION_RECEIVED](state, payload) {
    state.agencies = payload.agencies
    state.organizations = _.uniqBy(_.map(_.clone(payload.agencies),
      (agency) => { return { id: agency.organization.id, name: agency.organization.display_name } }),
      'id')
  },
  [types.CASH_ORGANIZATIONS_OF_CUSTOMER](state, payload) {
    state.organizations = payload.organizations
  },
  [types.CASH_ORDERS_RECEIVED](state, payload) {
    var tmp = (_.filter(payload.data.orders, (order) => {
      return order.payable == true
    }))
    if (tmp.length > 0)
      state.orders_payable = _.concat(state.orders_payable, tmp)
    var tmp2 = _.filter(payload.data.orders, (order) => {
      return order.payable == false
    })
    if (tmp2.length > 0)
      state.orders_unpayable = _.concat(state.orders_unpayable, tmp2)
  },

  [types.CASH_CUSTOMERS_RECEIVED](state, payload) {
    state.customers = payload.customers
  },

  [types.CASH_PAYMENT_METHOD_RECEIVED](state, payload) {
    var tmp = _.find(state.payments_methods, (pm) => pm.order_id == payload.order_id)
    if (tmp == undefined) {
      var tmp2 = _.map(payload.methods,
        function (pl, idx) {
          return {
            id: idx,
            name: pl.block.title,
            order_id: payload.order_id
          }
        }
      )
      state.payments_methods = _.concat(state.payments_methods, tmp2)
    }
  },
  [types.CASH_VALIDATION_REQUESTS_RECEIVED](state, payload) {
    state.validation_requests = payload.validation_requests
  },

  [types.CASH_CUSTOMERS_FOR_ADD_CASH_RECEIVED](state, payload) {
    state.customers_for_add_cash = _.map(payload.customers, customer => {
      return {id:customer.id, name:customer.name + ' (' + customer.erp_id +')'}
    })
  },

  [types.CASH_CUSTOMER_CASHINGS_RECEIVED](state, payload) {
    state.cashings = payload.customer_cashings
  },

  [types.CASH_CUSTOMER_CASHINGS_PAYMENT_FORM_RECEIVED](state, payload) {
    state.customer_cashings_payment_methods = payload.payment_methods
  },

  [types.CASH_CUSTOMER_INVOICES_RECEIVED](state, payload) {
    state.invoices = payload.invoices
  },

  [types.CASH_CUSTOMER_CASHINGS_FILTER_UPDATED](state, payload) {
    state.filters = payload
  },

  [types.CASH_CUSTOMER_CASHING_CREATED_AND_WAITING_FOR_PAYMENT](state, payload) {
    state.cashing_created_and_waiting_for_payment = payload.customer_cashing
  },

  [types.CASH_CUSTOMER_BALANCE_RECEIVED](state, payload) {
    state.balance = payload.balance_state
  },
}

const actions = {
  agenciesWithOrganization({ commit, state }) {
    return api.get_agencies_with({ with: "organization" })
      .then((response) => commit(types.CASH_AGENCIES_WITH_ORGANIZATION_RECEIVED, response.data))
  },
  ordersOfCustomer({ commit, state }, params) {
    state.orders_payable = []
    state.orders_unpayable = []
    return api.getOrders(params.customer_id, params.params)
      .then((response) => commit(types.CASH_ORDERS_RECEIVED, response))
  },

  customersOfAgencies({ commit, state }, params) {
    if (params.agencies.length > 0)
      return api.get_customers_for_cash({ params })
                .then((response) => commit(types.CASH_CUSTOMERS_RECEIVED, response.data))
    else
      commit(types.CASH_CUSTOMERS_RECEIVED, {customers: []})
  },

  paymentsMethodsOf({ commit, state }, orderId) {
    return api.payments_methods_of(orderId)
      .then((response) => commit(types.CASH_PAYMENT_METHOD_RECEIVED, { order_id: orderId, methods: response.data.payment_methods }))
  },

  validationRequests({ commit, state }, params) {
    return api.validation_requests({ params })
      .then((response) => commit(types.CASH_VALIDATION_REQUESTS_RECEIVED, response.data))
  },

  customersOfAgencyForAdd({ commit, state }, params) {
    return api.get_customers_for_cash({ params })
      .then((response) => commit(types.CASH_CUSTOMERS_FOR_ADD_CASH_RECEIVED, response.data))
  },

  customerCashings({ commit, state }, params) {
    return api.get_customer_cashings(state.filters)
      .then((response) => commit(types.CASH_CUSTOMER_CASHINGS_RECEIVED, response.data))
  },

  storeCustomerCashing({ commit, state }, params) {
    return api.post_customer_cashings(params)
      .then((response) => commit(types.CASH_CUSTOMER_CASHING_CREATED_AND_WAITING_FOR_PAYMENT, response.data))
  },

  deleteCashing({ commit, state }, params) {
    return api.del_customer_cashings(params)
  },

  customerCashingsPaymentMethods({ commit, state }, params) {
    return api.get_customer_cashings_payment_methods(params)
      .then((response) => commit(types.CASH_CUSTOMER_CASHINGS_PAYMENT_FORM_RECEIVED, response.data))
  },

  sendPayment({ commit, state }, params) {
    return api.post_customer_cashings_payment_methods(params.customer_cashing_id, params.params)
              .catch((error) => {
                  state.errors = error.response.data.errors
                  // console.warn(error)
                  // commit('FORM_ERROR', {})
                  // commit(types.FORM_ERROR, error.response.data.errors)
                  // return (api.del_customer_cashings(params.customer_cashing_id))
                })
              .then(() =>
                {
                  if (state.errors.length == 0)
                    state.cashing_created_and_waiting_for_payment = null
                })
  },

  invoicesOf({ commit, state }, params) {
    return api.get_customer_invoices(params.customer_id, params.params)
      .then((response) => commit(types.CASH_CUSTOMER_INVOICES_RECEIVED, response.data))
  },

  fetchSingleCustomer({ commit, state }, params) {
    return api.getCustomer(params)
      .then((response) => commit(types.CASH_CUSTOMERS_RECEIVED, response.data))
  },

  updateFilters({ commit }, params) {
    let customersID = _.map(params.selected_customers, c => c.id)
    let organizationsID = _.map(params.selected_organizations, o => o.id)

    let good_params = {
      customers: customersID,
      organizations: organizationsID,
      type: params.selected_type ? params.selected_type.value : null,
      date: params.selected_search_date,
      payable: params.selected_payable ? params.selected_payable.value : null,
      per_page: 25,
      with: "customer;entries;payments;invoices",
      paginate: 1,
    }
    commit(types.CASH_CUSTOMER_CASHINGS_FILTER_UPDATED, good_params)
  },

  searchCustomerForAddCash({ commit }, params) {

    if (params.search != null && params.search.length > 2)
    {
      let completeParams = _.assign(params, {validated: 1, paginate: 0, eager_loading: 0})

      return Vue.axios.get('customers', {params: completeParams})
                .catch((error) => console.warn(error.errors))
                .then((response) => commit(types.CASH_CUSTOMERS_FOR_ADD_CASH_RECEIVED, response.data))
    }
  },

  resetCustomerForAddCash({ state }) {
    state.customers_for_add_cash = []
  },

  organizationsOfCustomer({ commit }, customer_id) {
    return api.organizations_of_customer(customer_id)
      .then((response) => commit(types.CASH_ORGANIZATIONS_OF_CUSTOMER, response.data))
  },

  clearCashingInStandBy({ state }, params) {
    return api.del_customer_cashings(params)
              .then(() => state.cashing_created_and_waiting_for_payment = null)
  },

  fetchCustomerBalance({ commit }, params) {
    // reinit balance
    commit(types.CASH_CUSTOMER_BALANCE_RECEIVED, {})
    return api.get_balance(params.customerId, {refresh:params.refresh})
      .then((response) => commit(types.CASH_CUSTOMER_BALANCE_RECEIVED, response.data))
  },

  fetchSingleCustomerCashings({ commit }, params) {
    return api.get_customer_cashings(params)
      .then((response) => commit(types.CASH_CUSTOMER_CASHINGS_RECEIVED, response.data))
  },

  reset_errors ({state})
  {
    state.errors = []
  },

  clear_single_error({state}, key)
  {
    delete state.errors[key]
  },

  set_cashing_waiting_for_payement({state}, data)
  {
    state.cashing_created_and_waiting_for_payment = data
  },

  cancelAuthorizations({ commit, state }, params) {
    return api.cancel_cashing_authorizations(params)
  },
  
  captureAuthorizations({ commit, state }, params) {
    return api.capture_cashing_authorizations(params)
  }
}

const getters = {
  any_errors(state){
    return state.errors && _.keys(state.errors).length > 0 ? true : false
  },

  errors(state)
  {
    return state.errors
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./client/store/modules/cash.js